module.exports = __webpack_public_path__ + "static/media/ic_position_stable.7a191374.png";